export default "__VITE_ASSET__aadc5827__"